import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import BloodGlucoseQueryTable from './BloodGlucoseQueryTable';
import { ClearAllSessionFiltersAction, FetchBloodGlucoseSessionsAction } from './BloodGlucoseActions';
import { MainState } from '../Core/reducers';
import DocumentTitle from '../misc/components/DocumentTitle';
import { useWebPortalLegacyClient } from '../misc/api/WebPortalTokenClient';

declare const window: any;

export interface BloodGlucoseListScreenProps {
    isMultiStudy: boolean;

    dispatch?: Redux.Dispatch<MainState>;
} 

export const BloodGlucoseListScreen = (props: BloodGlucoseListScreenProps) => {

    const legacyClient = useWebPortalLegacyClient();

    const clearAllFilters = () => {
        props.dispatch(ClearAllSessionFiltersAction.create());
        props.dispatch(FetchBloodGlucoseSessionsAction.create(legacyClient));
    }

    return (
        <DocumentTitle title="Blood Glucose Sessions | Vitalograph Web Portal">
            <>
                <div className="row">
                    <div className="col-md-6">
                        <h2 className='text-primary'>Blood Glucose Sessions</h2>
                    </div>
                    <div className="col-md-6">
                        <div className="h2 pull-right">
                            <button className="btn btn-primary" onClick={() => clearAllFilters()}>Clear All Filters</button>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='panel panel-default'>
                            <div className='panel-body'>
                                <div className='table-responsive'>
                                    <BloodGlucoseQueryTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </DocumentTitle>
    );
};

function mapStateToProps(state: MainState) {
    return {
    }
}

export default connect(mapStateToProps)(BloodGlucoseListScreen);
